<div class="dialog-content">
    <div mat-dialog-content>
        {{message}}
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="cancel()">Cancel</button>
        <button mat-raised-button
                color="primary"
                (click)="onSubmit()">
                Ok
        </button>
    </div>
</div>

